export function getFormTitle(form: any): string {
    return form && form.components && form.components.length ? form.components[0].title : '';
}
